module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"approved":"Approved","approvedNot":"Not approved","shouldApprove":"Needs approval"}}')
  delete Component.options._Ctor
}
